'use client'

import { useState } from 'react'
import { Box } from '@mui/material'
import { tokens } from '../lib/tokens'
import type { MedecinData } from '../model/types'
import { useProfessionalInfo } from '../model/useProfessionalInfo'
import { CollapsedBanner } from './CollapsedBanner'
import { ExpandedBanner } from './ExpandedBanner'

interface ProfessionalInfoBannerProps {
  medecin: MedecinData
}

export function ProfessionalInfoBanner({ medecin }: ProfessionalInfoBannerProps) {
  const [expanded, setExpanded] = useState(false)
  const info = useProfessionalInfo(medecin)

  return (
    <Box sx={{ px: { xs: 1, md: 2 }, py: 1, bgcolor: tokens.surface, zIndex: 10 }}>
      {expanded ? <ExpandedBanner info={info} onCollapse={() => setExpanded(false)} /> : <CollapsedBanner info={info} onExpand={() => setExpanded(true)} />}
    </Box>
  )
}
